export const addCoursePurchaseModalReducerActions = {
	OPEN: 0,
	HIDE: 1,
};

export const addCoursePurchaseModalReducer = (state, action) => {
	switch (action.type) {
		case addCoursePurchaseModalReducerActions.OPEN:
			return { ...state, show: true };

		case addCoursePurchaseModalReducerActions.HIDE:
			return { ...state, show: false };

		default:
			throw Error("undefined action at addCoursePurchaseModalReducer");
	}
};
